export function getPageWidth() {
    return (
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
    );
}
export function judgeIsMob() {
    return getPageWidth() <= 640;
}
export function getPageHeight() {
    return (
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
    );
}
//根据屏幕迟勋分辨路动态调整fontSize
function getRootFs(){
    let designWidth = 1080; // 假设设计稿宽度为1080
    let baseFontSize = 100; // 基准大小
    const width = getPageWidth(); // 当前窗口宽度
    if (width <= 640) {
        designWidth = 375;
        baseFontSize = 10;
    }
    // const pixelRatio = window.devicePixelRatio || 1; // 设备像素比
    // const fontSize = (width / designWidth) * baseFontSize * pixelRatio; // 计算font-size
    let fontSize = Math.floor((width / designWidth) * baseFontSize);
    fontSize = fontSize >= 150 ? 150 : fontSize;
    return fontSize;
}
export function adjustFontSize() {
    document.documentElement.style.fontSize = `${getRootFs()}px`;
}
export function pxToRem(size) {
    const base = getRootFs();
    return size/base
}
export function RemToPx(size) {
    const base = getRootFs();
    return size*base
}
